import { IsBoolean, IsDefined, IsInt, IsISO8601, IsOptional, Matches} from 'class-validator';
import { Type } from 'class-transformer';

export class StockLevelDailySyncCountedTime {
  @IsDefined()
  @IsInt()
  @Type(() => Number)
  merchantId: number;

  @IsOptional()
  @IsISO8601()
  @Matches(/^\d{4}-\d{2}-\d{2}$/)
  countedDate: string;

  @IsOptional()
  @IsBoolean()
  @Type(() => Boolean)
  beforeTrading: boolean;
}